import { LAYOUTSTATE } from '.'
import { TLayoutState } from '../../types/state'
import { isAndroid, isIDevice, isIpad } from '../utilities/browser'
import { setLayoutState, updatePortalState } from './internal/layout'
import { calcFullscreenSizeSub } from './state.screen'

export const updateLayoutState = (layoutState: Partial<TLayoutState>) => {
    if (!layoutState || typeof layoutState !== 'object') return
    // const { expandedNav: prevExpandedNav } = LAYOUTSTATE.layout
    const nextLayoutState = { ...LAYOUTSTATE.layout, ...layoutState }
    // console.log('[updateLayoutState]', layoutState)
    setLayoutState(nextLayoutState)

    // if (!!nextLayoutState.expandedNav !== !!prevExpandedNav) {
    //     resetPortalDimensions(true)
    // }
    calcFullscreenSizeSub(nextLayoutState)
}

// const setPortalDimensions = (dimensions: TPortalDimensions) => {
//     if (isEqual(LAYOUTSTATE.portalDimensions, dimensions)) return
//     LAYOUTSTATE.portalDimensions = dimensions
//     pubSubLayout.emit(LayoutEvent.PORTAL_DIMENSIONS_CHANGE, dimensions, true)
// }

// export const resetPortalDimensions = (widthOnly?: boolean) => {
//     const { height, width, listeners } = LAYOUTSTATE.portalDimensions
//     if (listeners > 0) return
//     if (height === undefined && width === undefined) return
//     setPortalDimensions({
//         ...LAYOUTSTATE.portalDimensions,
//         ...(!widthOnly ? { height: undefined } : {}),
//         width: undefined,
//     })
// }

export const updateFocus = (quietFocus = false) => {
    if (isIDevice || isIpad || isAndroid) {
        updatePortalState({ composeFocused: true, quietFocus })
    }
}

export const updateBlur = (quietFocus = false) => {
    if (isIDevice || isIpad || isAndroid) {
        updatePortalState({ composeFocused: false, quietFocus })
    }
}
export const onInputFocus = () => {
    if (isIDevice || isIpad || isAndroid) {
        updatePortalState({ composeFocused: true, quietFocus: false })
    }
}

export const onInputBlur = () => {
    if (isIDevice || isIpad || isAndroid) {
        updatePortalState({ composeFocused: false, quietFocus: false })
    }
}
